import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import Loading from '../../components/Loading/Loading';
import CompanyForm from './CompanyForm';
import {Translate} from 'react-redux-i18n';

import {
  fetchCompany as fetchCompanyAction,
  clearCompany as clearCompanyAction,
  setIsEdit as setIsEditAction,
  setError as setErrorAction,
} from './CompanyActions';

function Company(props) {
  const { loading, fetchCompany, clearCompany, setIsEdit, setError } = props;
  const { id } = useParams();

  useEffect(() => {
    setError({});

    if (id) {
      setIsEdit(true);
      fetchCompany(id);
    } else {
      setIsEdit(false);
      clearCompany();
    }

    return () => {
      clearCompany();
    };
  }, [id, fetchCompany, clearCompany, setIsEdit, setError]);

  return (
    <div className="row">
      <div className="col-md-12 mt-4">
        { loading && <Loading /> }
        <h3><strong><Translate value="company.title"/></strong></h3>
        <hr />
        <Translate value="company.desc"/>
        <div>
          <CompanyForm companyId={id} />
        </div>
      </div>
    </div>
  );
}

Company.propTypes = {
  loading: PropTypes.bool,
  fetchCompany: PropTypes.func,
  clearCompany: PropTypes.func,
  setIsEdit: PropTypes.func,
  setError: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.company.loading,
  errors: state.company.errors,
});

const mapDispatchToProps = {
  fetchCompany: fetchCompanyAction,
  clearCompany: clearCompanyAction,
  setIsEdit: setIsEditAction,
  setError: setErrorAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Company);
